export const fonts = {
	fontFamily: 'IBMPlex',
	fontFamilyTitle: 'IBMPlex',
}
